var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifislash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.072 2.326 35.874 29.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "sf-cc-wifi-slash-cut0",
    maskUnits: "userSpaceOnUse",
    x: -100,
    y: -100,
    width: 300,
    height: 300
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 300,
    height: 300,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.38 31.776C30.704 33.081 32.843 33.074 34.141 31.744C35.417 30.436 35.413 28.348 34.121 27.051L8.379 1.308C7.07 0 4.928 0 3.627 1.301C2.341 2.602 2.341 4.772 3.646 6.034Z",
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sf-cc-wifi-slash-cut0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.517 17.107C2.849 17.458 3.381 17.455 3.725 17.084C7.516 13.07 12.461 10.969 18.005 10.969C23.589 10.969 28.554 13.086 32.341 17.107C32.653 17.435 33.166 17.416 33.51 17.068L35.715 14.875C36.02 14.554 36.011 14.143 35.761 13.838C32.083 9.279 25.203 5.973 18.005 5.973C10.823 5.973 3.944 9.279 0.25 13.838C0 14.143 0.007 14.554 0.312 14.875Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.914 23.473C9.285 23.852 9.794 23.801 10.161 23.411C12.004 21.376 14.965 19.941 18.005 19.957C21.085 19.941 24.041 21.431 25.932 23.473C26.26 23.84 26.726 23.817 27.113 23.457L29.575 21.061C29.864 20.776 29.891 20.363 29.641 20.041C27.23 17.157 22.869 15.015 18.005 15.015C13.142 15.015 8.78 17.157 6.386 20.041C6.12 20.363 6.13 20.744 6.452 21.061Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.009 31.957C18.408 31.957 18.733 31.783 19.372 31.167L23.162 27.525C23.436 27.256 23.498 26.805 23.244 26.493C22.149 25.098 20.205 23.971 18.009 23.971C15.741 23.971 13.777 25.157 12.691 26.632C12.51 26.901 12.605 27.263 12.884 27.525L16.646 31.167C17.285 31.767 17.626 31.957 18.009 31.957Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.796 30.356C31.33 30.887 32.197 30.88 32.705 30.356C33.223 29.822 33.236 28.982 32.705 28.455L6.975 2.728C6.44 2.194 5.574 2.194 5.046 2.721C4.535 3.232 4.535 4.138 5.046 4.63Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifislash);
export default __webpack_public_path__ + "static/media/wifi.slash.fde57760750d0722680fc62314ed85c2.svg";
export { ForwardRef as ReactComponent };